import { _fetch } from "../helpers/_fetch";

const type = "auth/v1";

const ProfileAPI = {
  getMe: () => {
    let body = {
      method: "GET",
      body: {}
    };
    return _fetch(`${type}/me`, body);
  },
  putMe: paramBody => {
    let body = {
      method: "PUT",
      body: paramBody,
      withAuth: true
    };
    return _fetch(`${type}/me`, body);
  },
  putName: paramBody => {
    let body = {
      method: "PUT",
      body: paramBody
    };

    return _fetch(`${type}/name`, body);
  }
};

export default ProfileAPI;
